import { render, staticRenderFns } from "./ActivitiesList.vue?vue&type=template&id=3896bc3e&scoped=true"
import script from "./ActivitiesList.vue?vue&type=script&lang=ts"
export * from "./ActivitiesList.vue?vue&type=script&lang=ts"
import style0 from "./ActivitiesList.vue?vue&type=style&index=0&id=3896bc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896bc3e",
  null
  
)

export default component.exports